export default __webpack_public_path__ + "static/media/validasi-admin-purchasing.8713b2e9.png";